// @ts-ignore
import { findIn, findAllIn, trigger, executeScriptTags } from "@elements/dom-utils";
// @ts-ignore
import { initInScope } from "@elements/init-modules-in-scope";
export function renderTemplate(renderItem, selectors) {
    let template = findIn(selectors.template, renderItem);
    if (template) {
        let parent = renderItem.parentElement;
        if (parent) { // add this check to prevent parent being null
            //everything about the overlay will be overwritten
            parent.innerHTML = "";
            executeScriptTags(template.innerHTML);
            parent.insertAdjacentHTML('beforeend', template.innerHTML);
            executeExternalScriptTags(parent);
            initInScope(parent);
        }
        else {
            console.error("renderItem does not have a parent element");
        }
    }
    //@ts-ignore
    trigger('consent-overlay.render-template', window);
}
function executeExternalScriptTags(markup) {
    let scriptTags = findAllIn('script[src]', markup);
    scriptTags.forEach((scriptTag) => {
        let parent = scriptTag.parentElement;
        let src = scriptTag.getAttribute('src');
        if (parent && src) {
            let tmpScriptTag = document.createElement('script');
            tmpScriptTag.setAttribute('src', src);
            parent.appendChild(tmpScriptTag);
            scriptTag.remove();
        }
    });
}
